<template lang="pug">
div
  v-sheet.scrollable(:min-height="height")
    div.d-flex.align-center.justify-end.fill-height.py-2.px-3
      y-button(:label="uploadedFileCount ? $tc('files', uploadedFileCount) : 'Upload file'" outlined color="neutral400" text-color="neutral700" prepend-icon="$yzi-attachment-01" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2" @click="showAddEditFileDialog = true")
    v-divider
    div.pa-5
      div.text-sm.neutral400--text(v-if="!consultation.note") No consultation notes available
      div.text-sm(v-else v-html="consultation.note")

  .dialogs
    add-edit-file-dialog(v-if="showAddEditFileDialog" :open.sync="showAddEditFileDialog" :pid="leadPid" @onUpdateCount="updateFileCount")

</template>

<script>
import { mapGetters } from 'vuex'
import AddEditFileDialog from '@/components/clinic/dialogs/AddEditFileDialog.vue'
 
export default {
  name: 'TextEditor',
  props: ['height'],
  components: { AddEditFileDialog },
  data () {
    return {
      showAddEditFileDialog: false,
    }
  },
  mounted () {},
  computed: {
    ...mapGetters({
      consultation: 'treatment/getConsultation',
      leadPid: 'treatment/getLeadPid',
    }),
    uploadedFileCount () {
      return this.consultation.attachments.length
    },
  },
  methods: {
    updateFileCount (items) {
      let files = items.map(m => m.id)
      this.$store.commit('treatment/updateConsultation', { attachments: files })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "files" : "1 file in this case notes | {n} files in this case notes"
  }
}
</i18n>